import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const CASummaryEntFifthSectInfo = ({ memriUsers }) => {
  const [selectedMEMRIUsers, setSelectedMEMRIUsers] = useState([]);

  useEffect(() => {
    const users = memriUsers.filter(item => item.isSelected === 1);
    setSelectedMEMRIUsers(users);
  }, [memriUsers]);

  return (
    <React.Fragment>
      <div className="ent-section-header-codes">
        <div>
          <span className="summary-sp-col">MEMRI Users</span>
        </div>
      </div>
      {selectedMEMRIUsers.length > 0 &&
        selectedMEMRIUsers.map(item => {
          const title = item.displayMemriUser;
          return (
            <div className="access-codes-list" title={title}>
              <span>{item.displayMemriUser}</span>
            </div>
          );
        })}
    </React.Fragment>
  );
};

CASummaryEntFifthSectInfo.propTypes = {
  memriUsers: PropTypes.arrayOf(PropTypes.object),
};

export default CASummaryEntFifthSectInfo;
